import { render, staticRenderFns } from "./OwnerRateForm.vue?vue&type=template&id=3d053b2b&scoped=true&"
import script from "./OwnerRateForm.vue?vue&type=script&lang=js&"
export * from "./OwnerRateForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerRateForm.vue?vue&type=style&index=0&id=3d053b2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d053b2b",
  null
  
)

export default component.exports